import { FC, ForwardedRef, forwardRef, ReactNode } from 'react'
import { Checkbox, CheckboxProps } from '@chakra-ui/react'
import { useField } from 'formik'

import FormControl, { BaseProps } from '../FormControl'

export type CheckboxControlProps = BaseProps & {
  checkBoxProps?: CheckboxProps
  children?: ReactNode
}

export const CheckboxControl: FC<CheckboxControlProps> = forwardRef(
  (props: CheckboxControlProps, ref: ForwardedRef<HTMLInputElement>) => {
    const { name, label, children, checkBoxProps, ...rest } = props
    const [field, { error, touched }] = useField(name)
    const isChecked = field.value

    return (
      <FormControl name={name} {...rest}>
        <Checkbox
          {...field}
          id={name}
          isInvalid={!!error && touched}
          isChecked={isChecked}
          ref={ref}
          size='lg'
          {...checkBoxProps}
        >
          {label}
          {children}
        </Checkbox>
      </FormControl>
    )
  }
)
